import Link from 'next/link';
import { ChevronDown } from 'lucide-react';

export default function TechnologyNavigation({ items = [] }) {
  return (
    <nav aria-label="Primary navigation" className="hidden min-w-0 flex-1 justify-center xl:flex">
      <ul className="flex items-center gap-5 whitespace-nowrap text-[13px] font-bold uppercase tracking-[0.04em] text-black">
        {items.map(item => (
          <li key={item.id} className="group relative">
            <Link href={item.href} className="flex items-center gap-1 py-5 transition-colors hover:text-[#929191] focus-visible:text-[#929191] focus-visible:outline-none">
              {item.label}
              {item.children.length > 0 && <ChevronDown aria-hidden="true" className="h-3.5 w-3.5" />}
            </Link>
            {item.children.length > 0 && (
              <ul className="invisible absolute left-0 top-full z-50 min-w-48 border border-[#e5e5e5] bg-white py-2 opacity-0 shadow-lg transition-all group-hover:visible group-hover:opacity-100 group-focus-within:visible group-focus-within:opacity-100">
                {item.children.map(child => (
                  <li key={child.id}>
                    <Link href={child.href} className="block px-4 py-2.5 text-xs text-black transition-colors hover:bg-[#f1f1f1] hover:text-[#929191] focus-visible:bg-[#f1f1f1] focus-visible:outline-none">
                      {child.label}
                    </Link>
                  </li>
                ))}
              </ul>
            )}
          </li>
        ))}
      </ul>
    </nav>
  );
}
